import React, { useState, useEffect, useCallback } from 'react';
import { RefreshCw } from 'lucide-react';

function generateQuestion() {
  const ops = ['+', '-', '×'];
  const op = ops[Math.floor(Math.random() * ops.length)];
  let a, b, answer;
  if (op === '+') {
    a = Math.floor(Math.random() * 9) + 1;
    b = Math.floor(Math.random() * 9) + 1;
    answer = a + b;
  } else if (op === '-') {
    a = Math.floor(Math.random() * 9) + 5;
    b = Math.floor(Math.random() * (a - 1)) + 1;
    answer = a - b;
  } else {
    a = Math.floor(Math.random() * 5) + 2;
    b = Math.floor(Math.random() * 4) + 2;
    answer = a * b;
  }
  return { question: `${a} ${op} ${b}`, answer: String(answer) };
}

export default function MathCaptcha({ onVerify }) {
  const [q, setQ] = useState(generateQuestion);
  const [value, setValue] = useState('');
  const [status, setStatus] = useState('idle'); // idle | error | ok

  const refresh = useCallback(() => {
    setQ(generateQuestion());
    setValue('');
    setStatus('idle');
    onVerify(false);
  }, [onVerify]);

  useEffect(() => {
    onVerify(false);
  }, []);

  const handleChange = (e) => {
    const val = e.target.value;
    setValue(val);
    if (val.trim() === q.answer) {
      setStatus('ok');
      onVerify(true);
    } else {
      setStatus(val.length >= q.answer.length ? 'error' : 'idle');
      onVerify(false);
    }
  };

  return (
    <div className="space-y-1.5" data-testid="captcha-container">
      <label className="text-sm font-medium text-[var(--color-ink)]">
        Verifica anti-robot
      </label>
      <div className="flex items-center gap-3">
        {/* Domanda */}
        <div className="flex-shrink-0 bg-[var(--color-linen)] border border-[var(--color-border)] rounded-xl px-5 py-2.5 font-mono font-bold text-lg text-[var(--color-deep)] select-none tracking-widest min-w-[96px] text-center">
          {q.question} = ?
        </div>

        {/* Input risposta */}
        <input
          type="number"
          inputMode="numeric"
          value={value}
          onChange={handleChange}
          placeholder="?"
          className={`w-20 border-2 rounded-xl px-3 py-2.5 text-center font-mono font-bold text-lg outline-none transition-colors
            ${status === 'ok'    ? 'border-[var(--color-sage)]  bg-[var(--color-sage-soft)] text-[var(--color-sage)]' : ''}
            ${status === 'error' ? 'border-[var(--color-terracotta)] bg-[var(--color-terracotta-soft)]' : ''}
            ${status === 'idle'  ? 'border-[var(--color-border)] bg-[var(--color-paper)]' : ''}
          `}
          data-testid="captcha-input"
          aria-label={`Quanto fa ${q.question}?`}
          autoComplete="off"
        />

        {/* Rigenera */}
        <button
          type="button"
          onClick={refresh}
          className="p-2 text-[var(--color-muted-text)] hover:text-[var(--color-sage)] transition-colors rounded-lg hover:bg-[var(--color-sage-soft)]"
          title="Nuova domanda"
          aria-label="Genera nuova domanda"
          data-testid="captcha-refresh"
        >
          <RefreshCw size={16} />
        </button>
      </div>

      {status === 'error' && (
        <p className="text-xs text-[var(--color-terracotta)]" data-testid="captcha-error">
          Risposta errata, riprova oppure genera una nuova domanda.
        </p>
      )}
      {status === 'ok' && (
        <p className="text-xs text-[var(--color-sage)] font-medium" data-testid="captcha-ok">
          Verifica superata
        </p>
      )}
    </div>
  );
}
